export default function(value, withSymbol = true){
    if (typeof value !== "number") {
        return value;
    }

    let options = {
        minimumFractionDigits: 2
    };

    if (withSymbol) {
        options.style = "currency";
        options.currency = "EUR";
    }

    let formatter = new Intl.NumberFormat("nl-NL", options);
    // Return the results of the formatter
    return formatter.format((value / 100));
}
